module.exports = __webpack_public_path__ + "static/media/img4.7452ba33.png";